import { jsx as _jsx } from "react/jsx-runtime";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import React, { useEffect, useCallback } from 'react';
import { useToastContext } from './ToastContext';
let handleErrorModal = (open, desc) => {
    console.log(open, desc); // Added to fix lint, Will be overridden.
};
const Alert = React.forwardRef(function Alert(props, ref) {
    return _jsx(MuiAlert, { elevation: 6, ref: ref, variant: "filled", ...props });
});
const Toast = () => {
    const { message, open, setToastState, severityValue, setMessage, setSeverityValue } = useToastContext();
    const handleErrorModalFn = useCallback((open, desc) => {
        setMessage(desc);
        setSeverityValue('error');
        setToastState(open);
    }, [setMessage, setSeverityValue, setToastState]);
    useEffect(() => {
        handleErrorModal = handleErrorModalFn;
        return () => {
            handleErrorModal = (open, desc) => {
                console.log(open, desc);
            };
        };
    }, [handleErrorModalFn]);
    useEffect(() => {
        if (open) {
            globalThis.window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [open]);
    return (_jsx("div", { className: "toast-container", children: severityValue === 'error' ? (_jsx(Snackbar, { open: open, autoHideDuration: 3000, anchorOrigin: { vertical: 'top', horizontal: 'center' }, onClose: () => setToastState(false), style: { width: '100%' }, sx: { p: 0, m: 0, top: '20px', left: 0, mt: '-20px' }, children: _jsx(Alert, { iconMapping: {
                    error: _jsx(ErrorOutlineIcon, { fontSize: "inherit" })
                }, onClose: () => setToastState(false), severity: "error", sx: {
                    width: '-webkit-fill-available',
                    background: '#FBEAEA',
                    color: '#D32F2F'
                }, children: message }) })) : (_jsx(Snackbar, { open: open, autoHideDuration: 10000, anchorOrigin: { vertical: 'top', horizontal: 'center' }, onClose: () => setToastState(false), style: { width: '100%' }, sx: { p: 0, m: 0, top: '20px', left: 0 }, children: _jsx(Alert, { iconMapping: {
                    success: _jsx(CheckCircleOutlineIcon, { fontSize: "inherit" })
                }, onClose: () => setToastState(false), severity: "success", sx: {
                    width: '-webkit-fill-available',
                    background: '#EAF2EA',
                    color: '#26890D',
                    mt: '35px'
                }, children: message }) })) }));
};
export { handleErrorModal };
export default Toast;
